import { Inject, Injectable, Injector } from '@angular/core';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { LoginRequest, LoginResponse, Usuario } from '../models/auth.model';
import { UtilsBaseApiService } from '@brunsker/libs/core/utils/base-api';
import { ENVIRONMENT_TOKEN, Environment } from '@brunsker/libs/core/utils/http-log-interceptor/src';
import { CookiesService } from '@brunsker/libs/core/utils/cookies/src';

@Injectable({
  providedIn: 'root',
})
export class AuthApiService extends UtilsBaseApiService<AuthApiService> {
  user: Usuario | null;
  currentUser$$ = new BehaviorSubject<LoginResponse | null>(null);
  currentUser$ = this.currentUser$$.asObservable();

  constructor(
    @Inject(ENVIRONMENT_TOKEN) readonly environment: Environment,
    override readonly injector: Injector,
    private cookies: CookiesService
  ) {
    super('auth', injector, environment.BASE_API_URL);
    const hasUser = sessionStorage.getItem('user');

    this.user = hasUser ? JSON.parse(hasUser) : null;

    if (hasUser) {
      const userJSON = JSON.parse(hasUser);
      this.currentUser$$.next(userJSON);
    }
  }

  readonly LOGIN_CONTEXT = 'login';

  login(user: LoginRequest): Observable<LoginResponse> {
    return this.httpClient
      .post<LoginResponse>(
        `${this.BASE_URL}${this.CONTEXT}/${this.LOGIN_CONTEXT}`,
        user
      )
      .pipe(
        tap((user) => {
          const userStringify = JSON.stringify(user);
          sessionStorage.setItem('user', userStringify);
          this.currentUser$$.next(user);
        })
      );
  }

  logoff() {
    sessionStorage.removeItem('user');
    this.currentUser$$.next(null);
    this.cookies.deleteCookie('password');
  }

  deleteUser(id: number | string) {
    const QUERY_STRING = this.getQueryString({
      idVendedor: id,
    });
    return this.httpClient.delete(
      `${this.BASE_URL}${this.CONTEXT}?${QUERY_STRING}`
    );
  }

  getUser() {
    if (this.user) return this.user.username;
    return 'Vendedor';
  }
}
